import { css } from "@emotion/css";
import { text, themeTokens } from "@octopusdeploy/design-system-tokens";

export const menuItemClasses = {
    root: "MuiMenuItem-root",
};

export const menuItemStyles = css({
    [`&.${menuItemClasses.root}`]: {
        color: themeTokens.color.text.primary,
        backgroundColor: themeTokens.color.menuList.background.default,
        font: text.body.regular.large,
        wordBreak: "break-all",
        whiteSpace: "normal",
        textAlign: "left",

        [`&.${menuItemClasses.root}`]: {
            "&:hover": {
                color: themeTokens.color.text.primary,
                backgroundColor: themeTokens.color.menuList.background.hover,
            },
            "&:focus": {
                color: themeTokens.color.text.primary,
                backgroundColor: themeTokens.color.menuList.background.active,
            },
        },
    },
});
